const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const SurpriseItemAdd = () => import(/* webpackChunkName: "surprise" */ './category/item/view/add.vue');
const SurpriseItemEdit = () => import(/* webpackChunkName: "surprise" */ './category/item/view/edit.vue');
const SurpriseItemList = () => import(/* webpackChunkName: "surprise" */ './category/item/view/index.vue');
const SurpriseCategoryAdd = () => import(/* webpackChunkName: "surprise" */ './category/view/add.vue');
const SurpriseCategoryEdit = () => import(/* webpackChunkName: "surprise" */ './category/view/edit.vue');
const SurpriseCategoryList = () => import(/* webpackChunkName: "surprise" */ './category/view/index.vue');
const SurpriseSetting = () => import(/* webpackChunkName: "surprise" */ './setting/view/edit.vue');

export const ROUTE_NAME_SURPRISE = {
    SETTING: 'SurpriseSetting',
    CATEGORY: {
        INDEX: 'SurpriseCategoryList',
        ADD: 'SurpriseCategoryAdd',
        EDIT: 'SurpriseCategoryEdit',
        ITEM: {
            INDEX: 'SurpriseItemList',
            ADD: 'SurpriseItemAdd',
            EDIT: 'SurpriseItemEdit'
        }
    }
} as const;

export default [
    {
        path: '/app/:appId/surprise/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'setting',
                name: 'SurpriseSetting',
                component: SurpriseSetting,
                meta: { requiresAuth: true }
            },
            {
                path: 'category/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: 'SurpriseCategoryList',
                        component: SurpriseCategoryList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: 'SurpriseCategoryAdd',
                        component: SurpriseCategoryAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: 'SurpriseCategoryEdit',
                        component: SurpriseCategoryEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':categoryId/item/',
                        component: EmptyRouterView,
                        meta: { requiresAuth: true },
                        children: [
                            {
                                path: '',
                                name: 'SurpriseItemList',
                                component: SurpriseItemList,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'add',
                                name: 'SurpriseItemAdd',
                                component: SurpriseItemAdd,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: ':itemId',
                                name: 'SurpriseItemEdit',
                                component: SurpriseItemEdit,
                                meta: { requiresAuth: true }
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
